<template>
  <b-modal centered size="lg" id="profile" hide-header hide-footer>
    <UserForm :parentUser="currentUser" :parent="'profile'"/>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import UserForm from './UserForm'
export default {
  name: 'Profile',
  components: {
    UserForm
  },
  computed: {
    ...mapGetters({ currentUser: 'currentUser' })
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Profile.vue